import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { BASE_URL } from "../../constants";
import Header from "../Helper/Header";
import NewFooter from "../Helper/NewFooter";
import ContactForm from "../../components/ContactForm/ContactForm";
const ClimateTech = () => {
  return (
    <>
      <Header />
      <Container fluid>
        {/* Heading 1 */}
        <Row className="justify-content-center">
          <Col className="text-center">
            <h1 className="heading1">Empowering </h1>
          </Col>
        </Row>

        {/* Heading 2 */}
        <Row className="justify-content-center">
          <Col className="text-center">
            <h2 className="heading2">
              Climate Tech <br /> Innovators
            </h2>
          </Col>
        </Row>

        {/* First Grid */}
        <div>
          <Row className="justify-content-center align-items-end">
            {" "}
            {/* Add align-items-end here */}
            <Col md={4} className="left-box">
              <p>
                The path to a Net Zero future is driven by innovation, and
                climate tech pioneers are at the forefront of this
                transformation. However, navigating complex sustainability
                challenges—such as optimizing new technologies, scaling
                solutions, and securing investments—requires data-driven
                decision-making. That’s where Dsider comes in.
              </p>
            </Col>
            <Col md={8} className="d-flex align-items-end">
              {" "}
              {/* Add d-flex and align-items-end here */}
              <img
                src={`${BASE_URL}solutions/climate_tech.png`}
                alt="Climate Tech"
                className="right-image"
              />
            </Col>
          </Row>
        </div>

        {/* Second Grid */}
        <div className="container " style={{ marginTop: "6rem" }}>
          <Row className="d-flex justify-content-center align-items-center">
            <Col md={4}>
              <img
                src={`${BASE_URL}solutions/digital_twin_ simulations.png`}
                alt="Power"
                className="power-image"
              />
            </Col>
            <Col md={8}>
              <h3 className="innovation-heading">
                Accelerate Innovation with Digital Twin Simulations
              </h3>
              <ul className="innovation-list">
                <li>
                  Model and simulate real-world scenarios before implementation.
                </li>
                <li>
                  Test multiple strategies in a risk-free digital environment.
                </li>
                <li>Optimize system performance and reduce inefficiencies.</li>
                {/* Add 2 more list items here */}
              </ul>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col md={4}>
              <img
                src={`${BASE_URL}solutions/carbon_footprint.png`}
                alt="Power"
                className="power-image"
              />
            </Col>
            <Col md={8}>
              <h3 className="innovation-heading">
                Validate Impact with Carbon Abatement Analysis{" "}
              </h3>
              <ul className="innovation-list">
                <li>Quantify emissions reductions from your technology. </li>
                <li>
                  Compare multiple sustainability approaches to find the most
                  effective one.{" "}
                </li>
                <li>
                  Ensure regulatory compliance with carbon accounting standards.
                </li>
                {/* Add 2 more list items here */}
              </ul>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col md={4}>
              <img
                src={`${BASE_URL}solutions/cost_benefit_ analysis.png`}
                alt="Power"
                className="power-image"
              />
            </Col>
            <Col md={8}>
              <h3 className="innovation-heading">
                Secure Funding with Financial & Risk Assessment{" "}
              </h3>
              <ul className="innovation-list">
                <li>
                  Providing financial impact assessments to support investment
                  decisions.
                </li>
                <li>
                  Identifying risks in scaling new technologies and mitigating
                  them proactively.
                </li>
                <li>
                  Offering scenario planning to demonstrate long-term business
                  viability..
                </li>
                {/* Add 2 more list items here */}
              </ul>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col md={4}>
              <img
                src={`${BASE_URL}solutions/complex_datasets.png`}
                alt="Power"
                className="power-image"
              />
            </Col>
            <Col md={8}>
              <h3 className="innovation-heading">
                Seamless Data Integration for Smarter Decision-Making{" "}
              </h3>
              <ul className="innovation-list">
                <li>
                  Integration of multiple data sources into a unified platform.
                </li>
                <li>
                  Real-time analytics and reporting to track sustainability
                  progress.
                </li>
                <li>Scalable insights to adapt as your technology evolves..</li>
                {/* Add 2 more list items here */}
              </ul>
            </Col>
          </Row>
        </div>

        {/* Action Box */}
        <Row className="justify-content-center">
          <Col
            className="action-box"
            style={{
              display: "grid",
              gridTemplateRows: "auto 1fr",
              alignItems: "start",
              justifyItems: "start",
            }}
          >
            <h4 className="action-heading">
              Turn Climate <br /> Innovation into <br /> Action with Dsider
            </h4>
            <p
              className="action-text"
              style={{ justifySelf: "end", alignSelf: "end" }}
            >
              Dsider equips climate tech innovators with the tools to design,
              test, and deploy sustainability solutions faster and more
              effectively. Whether you're developing clean energy, carbon
              capture, circular economy solutions, or green infrastructure, our
              platform accelerates your journey from concept to impact.
            </p>
          </Col>
        </Row>
      </Container>
      <ContactForm showFooter={false}/>
      <NewFooter />
    </>
  );
};

export default ClimateTech;
